import { useCallback, useEffect, useState } from 'react';
import { fetchBuhServiceStatus } from '../api/buhServiceApi';
import { socket } from '../components/chat/useSocket';

export function useBuhServiceSuspended(userId) {
    const [suspended, setSuspended] = useState(false);

    const load = useCallback(async () => {
        if (!userId) {
            setSuspended(false);
            return;
        }
        try {
            const status = await fetchBuhServiceStatus(userId);
            setSuspended(!!status?.service_suspended);
        } catch (error) {
            console.error('useBuhServiceSuspended', error);
            setSuspended(false);
        }
    }, [userId]);

    useEffect(() => {
        if (!userId) {
            setSuspended(false);
            return undefined;
        }

        const onStatusChanged = (payload) => {
            if (Number(payload?.user_id) !== Number(userId)) return;
            setSuspended(!!payload?.service_suspended);
        };

        const onNewPack = (payload) => {
            if (Number(payload?.user_id) !== Number(userId)) return;
            load();
        };

        load();
        socket.on('buhServiceStatusChanged', onStatusChanged);
        socket.on('newPack', onNewPack);

        return () => {
            socket.off('buhServiceStatusChanged', onStatusChanged);
            socket.off('newPack', onNewPack);
        };
    }, [userId, load]);

    return suspended;
}
